import { h, defineComponent } from 'vue';
import { box, col, cols, container, pageSubtitle } from '@/ui/components';
import { Icon } from '@/ui/components/icon/Icon';
import { t } from '@/ui/i18n/i18n';
import { operatingSystemToStoreBadge } from '@/ui/helpers';
import { appStoreBadge, googlePlayStoreBadge } from '@/ui/components/onboarding/StoreImageLink';
import { Button } from '@/ui/components/Button';
// @ts-ignore
import is from 'is_js';
import { CheckboxList, CheckboxListResource, Type } from '@/ui/components/CheckboxList';

export const WelcomePage = defineComponent({
  name: 'WelcomePage',
  setup() {
    const buildSteps = (title: string, image: string, list: string[]) => {
      const listTransformed: CheckboxListResource[] = list.map(check => ({ type: Type.Included, text: check }));

      return cols([
        col([
          h('h3', { class: 'welcome-page__steps-title' }, title),
          h('img', { attrs: { src: image, class: 'welcome-page__step-image' } }),
        ], true, 'is-offset-3'),
        col([
          h(CheckboxList, { props: { list: listTransformed } }),
        ]),
      ], 'welcome-page__steps is-mobile is-0');
    };

    const welcomeToLumiform = h('div', { class: 'welcome-page__title' }, [
      pageSubtitle(t('welcome-page.welcome')),
      h('div', t('welcome-page.welcome-subtext')),
    ]);

    const whatsNext = h('div', { class: 'welcome-page__title' }, [
      pageSubtitle(t('welcome-page.whats-next')),
      h('div', t('welcome-page.whats-next-subtext')),
    ]);

    const desktopSteps = buildSteps(t('welcome-page.desktop'), 'images/desktop.svg', [
      t('welcome-page.list.build-template'),
      t('welcome-page.list.conduct-inspections'),
      t('welcome-page.list.manage-issues'),
      t('welcome-page.list.manage-data'),
    ]);

    const mobileSteps = buildSteps(t('welcome-page.mobile'), 'images/mobile.svg', [
      t('welcome-page.list.conduct-inspections'),
      t('welcome-page.list.raise-solve-issues'),
      t('welcome-page.list.view-reports'),
    ]);

    const isSupportedMobileOperatingSystem = is.ios() || is.android();

    const propsBadge = { classes: 'welcome-page__store-badges' };

    const downloadStoreBadge = isSupportedMobileOperatingSystem
      ? operatingSystemToStoreBadge(propsBadge)
      : [
        appStoreBadge(propsBadge),
        googlePlayStoreBadge(propsBadge),
      ];

    const storeLink = is.ios() ? process.env.VUE_APP_IOS_APP_URL : process.env.VUE_APP_ANDROID_APP_URL;

    return function render() {
      return h('div', { class: 'welcome-page' }, [
        container([
          box([
            h(Icon, {
              props: {
                icon: 'check-circle',
                classes: 'check-circle-icon',
                iconPack: 'fal',
              },
            }),
            welcomeToLumiform,
            whatsNext,
            desktopSteps,
            mobileSteps,
            isSupportedMobileOperatingSystem
              ? h(Button, {
                props: { tag: 'a' },
                attrs: { href: storeLink, target: '_blank' },
              }, t('welcome-page.download-mobile-app'))
              : h('div', { class: 'has-text-centered' }, t('welcome-page.unsupported-os')),
            downloadStoreBadge,
            h(
              'div',
              { class: 'has-text-centered' },
              t('welcome-page.footnote'),
            ),
          ]),
        ], 'small', 'px-8 pb-8'),
      ]);
    };
  },
});
